// Added by Josep until this Gallery detail is more mature TS wise
import PropTypes from 'prop-types'
import GalleryProfile from '@components/GalleryProfile'
import ModuleProvider from './Provider'

function GalleryProfileModule(props) {
  return (
    //@ts-ignore
    <ModuleProvider CMSProps={props}>
      {/** @ts-ignore */}
      <GalleryProfile />
    </ModuleProvider>
  )
}

GalleryProfileModule.propTypes = {
  CMSProps: PropTypes.object
}

export default GalleryProfileModule
